import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const ContactInput = () => {
  const { contactId = '' } = useParams();
  const decodedId = contactId ? atob(contactId) : contactId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'contact';

  useEffect(() => {
    if (contactId) {
      setIsEditing(true);
      fetchContactDetails();
    }
  }, [contactId]);

  const fetchContactDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.contact}${id}/`, { headers });
      const contactDetails = response.data;

      setFormData(contactDetails);
    } catch (error) {
      console.error('Error fetching contact details:', error);
    }
  };

  const contactFields = [
    { name: 'name', label: 'Name', type: 'text' },
    { name: 'email', label: 'Email', type: 'email' },
    { name: 'phone', label: 'Phone', type: 'text' },
    { name: 'company', label: 'Company', type: 'text' },

    // Add other fields as needed for your Contact model
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Contact Details' : 'Create Contact'}</h1>
      <FormComponent fields={contactFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default ContactInput;
